import {useContext} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import DepartamentContext from 'context/DepartamentContext';

let myAbilities = HelpAbility();

function Item({i, departament: depa, deleteDepartament}){
 const {setDepartament} = useContext(DepartamentContext);
 const {_id, codLogistica, departamento, ciudad, estado} = depa;

 const handleIsUpdateForm = () => {
    setDepartament({...depa})
 }
 
 const handleDeleteDepartament = async () => {
    deleteDepartament({id: _id})
 }

 return (
   <tr>
      <th className="text-center" scope="row">{i + 1}</th>
      <td className="text-center">{codLogistica}</td>
      <td className="text-center">{departamento}</td>
      <td className="text-center">{ciudad}</td>
      <td className="text-center">{estado ? `✔` : `❌`}</td>

      {myAbilities.hasAny([C.A.DEPARTAMENT.UPDATE, C.A.DEPARTAMENT.DELETE]) && <td className="text-center d-flex">
          {myAbilities.has(C.A.DEPARTAMENT.UPDATE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={handleIsUpdateForm}>
                  <i className="bi bi-pencil-square"/>
              </button>
          </OverlayTrigger>}
          {myAbilities.has(C.A.DEPARTAMENT.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-danger"
                      onClick={handleDeleteDepartament}>
                  <i className="bi bi-trash"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item

